export enum DocumentTemplatesTypes {
  COMMERCIAL_INVOICE = 'commercial_invoice',
  PURCHASE_ORDER = 'purchase_order',
  QUOTATION = 'quotation',
  PROFORMA_INVOICE = 'proforma_invoice',
  PACKING_LIST = 'packing_list',
  TRUCKLOAD_BOL = 'truckload_bol',
  "SHIPPER'S_LETTER_OF_INSTRUCTION" = "shipper's_letter_of_instruction"
}
